import { alpha } from '@mui/material/styles';
import { inputBaseClasses } from '@mui/material/InputBase';
import { inputLabelClasses } from '@mui/material/InputLabel';
import { filledInputClasses } from '@mui/material/FilledInput';
import { outlinedInputClasses } from '@mui/material/OutlinedInput';
// ----------------------------------------------------------------------
export function textField(theme) {
    const color = {
        focused: theme.palette.text.secondary,
        active: theme.palette.text.secondary,
        placeholder: theme.palette.text.disabled
    };
    const font = {
        label: theme.typography.body1,
        value: theme.typography.body2
    };
    return {
        // HELPER
        MuiFormHelperText: {
            styleOverrides: {
                root: {
                    marginTop: theme.spacing(1)
                }
            }
        },
        // LABEL
        MuiFormLabel: {
            styleOverrides: {
                root: Object.assign(Object.assign({}, font.value), { color: color.placeholder, [`&.${inputLabelClasses.shrink}`]: Object.assign(Object.assign({}, font.label), { fontWeight: 600, color: color.active, [`&.${inputLabelClasses.focused}`]: {
                            color: color.focused
                        }, [`&.${inputLabelClasses.error}`]: {
                            color: theme.palette.error.main
                        }, [`&.${inputLabelClasses.disabled}`]: {
                            color: theme.palette.text.disabled
                        }, [`&.${inputLabelClasses.filled}`]: {
                            transform: 'translate(12px, 6px) scale(0.75)'
                        } }) }),
                asterisk: {
                    color: theme.palette.error.main,
                },
            }
        },
        // BASE
        MuiInputBase: {
            styleOverrides: {
                root: {
                    [`&.${inputBaseClasses.disabled}`]: {
                        '& svg': {
                            color: theme.palette.text.disabled
                        }
                    },
                    '& .MuiInputAdornment-root .MuiIconButton-root': {
                        marginRight: '-4px',
                        width: '32px',
                        height: '32px',
                    },
                },
                input: Object.assign(Object.assign({}, font.value), { '&::placeholder': {
                        opacity: 1,
                        color: color.placeholder
                    } })
            }
        },
        // STANDARD
        MuiInput: {
            styleOverrides: {
                underline: {
                    '&:before': {
                        borderBottomColor: alpha(theme.palette.grey[500], 0.32)
                    },
                    '&:after': {
                        borderBottomColor: color.focused
                    }
                }
            }
        },
        // OUTLINED
        MuiOutlinedInput: {
            styleOverrides: {
                root: {
                    [`&.${outlinedInputClasses.focused}`]: {
                        [`& .${outlinedInputClasses.notchedOutline}`]: {
                            borderColor: '#919EAB33'
                        }
                    },
                    [`&.${outlinedInputClasses.error}`]: {
                        [`& .${outlinedInputClasses.notchedOutline}`]: {
                            borderColor: theme.palette.error.main
                        }
                    },
                    [`&.${outlinedInputClasses.disabled}`]: {
                        [`& .${outlinedInputClasses.notchedOutline}`]: {
                            borderColor: theme.palette.action.disabledBackground
                        }
                    },
                    borderRadius: 8
                },
                notchedOutline: {
                    borderColor: alpha(theme.palette.grey[500], 0.2),
                    transition: theme.transitions.create(['border-color'], {
                        duration: theme.transitions.duration.shortest
                    })
                }
            }
        },
        // FILLED
        MuiFilledInput: {
            styleOverrides: {
                root: {
                    borderRadius: '40px',
                    overflow: 'hidden',
                    backgroundColor: alpha(theme.palette.grey[500], 0.08),
                    '&:hover': {
                        backgroundColor: alpha(theme.palette.grey[500], 0.16)
                    },
                    [`&.${filledInputClasses.focused}`]: {
                        backgroundColor: alpha(theme.palette.grey[500], 0.16)
                    },
                    [`&.${filledInputClasses.error}`]: {
                        backgroundColor: alpha(theme.palette.error.main, 0.08),
                        [`&.${filledInputClasses.focused}`]: {
                            backgroundColor: alpha(theme.palette.error.main, 0.16)
                        }
                    },
                    [`&.${filledInputClasses.disabled}`]: {
                        backgroundColor: '#919EAB14',
                        border: '1px dashed #919EAB33',
                        '&:before': {
                            borderBottom: 'none !important'
                        },
                        '&:after': {
                            borderBottom: 'none !important'
                        }
                    },
                    '&:before': {
                        borderBottom: 'none'
                    },
                    '&:after': {
                        borderBottom: 'none'
                    },
                    '&:hover:not(.Mui-disabled):before': {
                        borderBottom: 'none'
                    },
                    [`&.${filledInputClasses.multiline}`]: {
                        borderRadius: theme.spacing(3),
                        alignItems: 'flex-start',
                        paddingTop: theme.spacing(2.5),
                        paddingBottom: theme.spacing(1.5),
                        paddingLeft: theme.spacing(1.75),
                        paddingRight: theme.spacing(1.75)
                    },
                    '& .MuiInputBase-inputMultiline': {
                        padding: 0,
                        resize: 'none'
                    }
                }
            }
        }
    };
}
